import type React from "react"
import { memo, useEffect, useState, useMemo, useCallback } from "react"
import styles from "./BillsSidemenuButton.module.scss"
import { useLocation, useNavigate } from "react-router-dom"

type SubMenuProps = {
  text: string
  icon?: React.ReactNode
  isActiveIcon?: React.ReactNode;
  colapsedText?: string
  route: string
  disabled?: boolean
}

export type BillsSideMenuButtonProps = {
  text: string
  icon?: React.ReactNode
  isActiveIcon?: React.ReactNode
  route?: string
  disabled?: boolean
  executeWrapper?: (func: () => void) => void
  colapsed: boolean
  isDisabled: boolean
  subMenuItems?: SubMenuProps[]
  onSubMenuInteraction?:
   (mainMenuName: string, subMenuItems: SubMenuProps[], isOpen: boolean, activeSubMenuItem?: string) => void;
  currentOpenSubmenu?: string | null;
}

const BillsSideMenuButton: React.FC<BillsSideMenuButtonProps> = memo((props: BillsSideMenuButtonProps) => {
  const { text, icon, isActiveIcon, route, disabled, subMenuItems, isDisabled, executeWrapper, onSubMenuInteraction,
    currentOpenSubmenu  } = props

  const isSubmenuOpen = currentOpenSubmenu === text;

  const navigator = useNavigate()
  const location = useLocation()

  const currentPath = location.pathname

   const isMenuActive = useMemo(() => {
    if (disabled) return false;
    
    if (route && currentPath === route) return true;
    
    if (subMenuItems && subMenuItems.length > 0) {
      return subMenuItems.some(subItem => currentPath === subItem.route);
    }
    
    return false;
  }, [currentPath, route, subMenuItems, disabled]);

  const isCurrent = useMemo(() => {
    return (route?: string) => {
      if (disabled) return ""
      if (isMenuActive) return styles.sectionButtonSelected
      return ""
    }
  }, [currentPath, disabled])

  const navigateTo = useCallback(
    (path?: string) => {
      if (path) {
        navigator(path)
      }
    },
    [navigator],
  )

  const navigate = useCallback(
    (route?: string) => {
      if (executeWrapper) {
        executeWrapper(() => navigateTo(route))
      } else {
        navigateTo(route)
      }
    },
    [executeWrapper, navigateTo],
  )

  const buttonClick = useCallback(() => {
    if (isDisabled || disabled) return;
    
    if (subMenuItems && subMenuItems.length > 0) {
      const willOpen = !isSubmenuOpen;
      
      if (onSubMenuInteraction) {
        if (willOpen) {
          // Opening submenu - navigate to first submenu item
          const firstSubMenuItem = subMenuItems[0];
          navigate(firstSubMenuItem.route);
          onSubMenuInteraction(text, subMenuItems, willOpen, firstSubMenuItem.text);
        } else {
          // Closing submenu
          onSubMenuInteraction(text, subMenuItems, willOpen);
        }
      }
    } else {
      navigate(route);
    }
  }, [isDisabled, disabled, subMenuItems, isSubmenuOpen, navigate, onSubMenuInteraction, route, text]);

  useEffect(() => {
    console.log("rendering")
  }, [])

  // Memoize the showIcon function
  const showIcon = useMemo(() => {
    return (icon: React.ReactNode, activeIcon: React.ReactNode | undefined, route?: string) => {
     if (isMenuActive && activeIcon) {
        return activeIcon;
      }

      return icon
    }
  }, [currentPath])

 

  return (
    <div className={`${styles.colapsed} ${isDisabled ? styles.disabled : ""}`}>
      <button
        title={text}
        disabled={isDisabled}
        className={`standardButton ${styles.sectionButton} ${isCurrent(route)}`}
        onClick={buttonClick}
      >
        {showIcon(icon, isActiveIcon, route)}
        
      </button>
    </div>
  )
})

export default BillsSideMenuButton
    